import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    constructor() {
        super(...arguments);
        this.nav = null;
    }
    connect() {
        const navId = this.element.getAttribute("aria-controls");
        if (navId) {
            this.nav = document.getElementById(navId);
        }
        this.element.addEventListener("click", this.toggle.bind(this));
    }
    toggle(event) {
        this.element.hasAttribute("aria-expanded") ? this.hide(event) : this.show(event);
    }
    show(event) {
        this.element.setAttribute("aria-expanded", "true");
        if (this.nav) {
            this.nav.removeAttribute("data-mobile-is-hidden");
        }
    }
    hide(event) {
        this.element.removeAttribute("aria-expanded");
        if (this.nav) {
            this.nav.setAttribute("data-mobile-is-hidden", "true");
        }
    }
}
